import { render, staticRenderFns } from "./Lawsuits.vue?vue&type=template&id=9cf0251e&"
import script from "./Lawsuits.vue?vue&type=script&lang=js&"
export * from "./Lawsuits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports